declare const jQuery: any;
const $ = jQuery;

const maxRepeaterItems = 5;

export function initContactForms(): void
{
    $(".wpcf7-form").each(function () {
        initForm($(this));
    })
}

function initForm($wrap): void
{
    initRepeaters($wrap);
    initCheckboxHiders($wrap);
}

function initRepeaters($wrap): void
{
    $wrap.find(".repeater").each(function () {
        initRepeater($(this));
    });
}

function initRepeater($repeaterWrap): void
{
    const appendToFirstPlaceholderStr: string = $repeaterWrap.attr("data-append-to-first-placeholder");
    const appendToFirstPlaceholderData = appendToFirstPlaceholderStr ? appendToFirstPlaceholderStr.split(/\:/) : undefined;
    const appendToFirstPlaceholderInputName: string = appendToFirstPlaceholderData ? appendToFirstPlaceholderData[0] : undefined;
    const appendToFirstPlaceholderText: string = appendToFirstPlaceholderData ? appendToFirstPlaceholderData[1] : undefined;
    const appendToFirstPlaceholderInput = (appendToFirstPlaceholderInputName && appendToFirstPlaceholderText) ?
        $repeaterWrap.find(`[name="${appendToFirstPlaceholderInputName}"]`) : undefined;
    const appendToFirstPlaceholderOrigPlaceholder: string = appendToFirstPlaceholderInput ? appendToFirstPlaceholderInput.attr("placeholder") : undefined;
    if (appendToFirstPlaceholderInput)
    {
        appendToFirstPlaceholderInput.attr("placeholder", appendToFirstPlaceholderOrigPlaceholder + appendToFirstPlaceholderText);
    }
    const $innerWrap = $(`<div class="repeater-inner">`).appendTo($repeaterWrap);
    $repeaterWrap.children().each(function () {
        $innerWrap.append(this);
    });
    const $addBtnWrap = $(`<div class="repeater-add-btn-wrap">`);
    $repeaterWrap.append($addBtnWrap);
    let nextInputNameNumber: number = 2;
    const addItem = () => {
        if (appendToFirstPlaceholderInput)
        {
            appendToFirstPlaceholderInput.attr("placeholder", appendToFirstPlaceholderOrigPlaceholder);
        }
        const $currLastInnerWrap = $repeaterWrap.find(".repeater-inner").last();
        const $clonedInnerWrap = $innerWrap.clone();
        $clonedInnerWrap.find(`:input`).each(function () {
            const $input = $(this).val("");
            const name: string = incrementNumberedInputName($input.attr("name"), nextInputNameNumber);
            $input.attr("name", name);
        });
        ++nextInputNameNumber;
        if (nextInputNameNumber > maxRepeaterItems)
        {
            $addBtnWrap.css({ display: "none" });
        }
        $clonedInnerWrap.insertAfter($currLastInnerWrap);
        if (appendToFirstPlaceholderInput)
        {
            appendToFirstPlaceholderInput.attr("placeholder", appendToFirstPlaceholderOrigPlaceholder + appendToFirstPlaceholderText);
        }
    };
    $(`<button>Add Item</button>`).appendTo($addBtnWrap).on("click", addItem);
}

function incrementNumberedInputName(name: string, nextInputNameNumber: number): string
{
    if (!name.match(/._\d+$/))
    {
        console.warn("Failed to get incremented input name, got:", name);
        return name + "_" + nextInputNameNumber;
    }
    return name.replace(/_\d+$/, "_" + nextInputNameNumber);
}

function initCheckboxHiders($wrap): void
{
    const $hiderWraps = $wrap.find(`[data-if-checked-hide]`);
    $hiderWraps.each(function () {
        const $hiderWrap = $(this);
        const $hiderCheckbox = $hiderWrap.find(`input[type="checkbox"]`);
        if ($hiderCheckbox.length === 0)
        {
            return;
        }
        const hideeInputName: string = $hiderWrap.attr("data-if-checked-hide");
        const $hideeInput = $wrap.find(`:input[name="${hideeInputName}"]`)
        const update = () => {
            $hideeInput.css({ display: $hiderCheckbox.prop("checked") ? "none" : "" });
            if ($hiderCheckbox.prop("checked"))
            {
                $hideeInput.filter(`textarea,input[type="text"],input[type="email"]`).val("");
            }
        };
        update();
        $(window).on("load", update);
        $hiderCheckbox.on("change", update);
    });
}
